<template>
    <v-list-item :to="{name: 'course', params: {id: course.id}}" class="course-list-item white" v-ripple="{class: 'ripple--color'}">
        <v-list-item-avatar width="115" height="75" rounded class="rounded-lg my-2">
            <!-- <v-avatar width="80" tile> -->
                <v-img cover :src="course.image_url"></v-img>
            <!-- </v-avatar> -->
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title>{{course.name}}</v-list-item-title>
            <v-list-item-subtitle>
                <span v-if="course.pay_type === 'course' && platform !== 'ios'">
                    <span v-if="course.joined" class="primary--text">اضغط لعرض الدورة</span>
                    <b v-else-if="course.price === 0" class="secondary--text">مجانية</b>
                    <b v-else class="primary--text">{{moneyFormat(course.price, true)}}</b>
                </span>
            </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon v-if="pcOnly" class="my-auto">
            <v-icon>mdi-chevron-left</v-icon>
        </v-list-item-icon>

        <template v-if="!course.joined">
            <course-join-dialog v-if="course.pay_type === 'lectures'" v-model="joinDialog" :course="course" />
            <course-purchase-dialog v-else v-model="joinDialog" :course="course" />
        </template>
    </v-list-item>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CourseJoinDialog from '@/components/custom/course-join-dialog'
import CoursePurchaseDialog from '@/components/custom/course-purchase-dialog'

export default {
    props: {
        course: {}
    },
    components: {CourseJoinDialog, CoursePurchaseDialog},
    data(){
        return {
            joinDialog: false,
        }
    },
    computed: {
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods
    }
}
</script>

<style lang="scss" scoped>
.course-list-item{
    cursor: pointer;
    align-items: flex-start;

    ::v-deep .v-list-item__title {
        white-space: normal;
        overflow: visible;
        text-overflow: unset;
        line-height: 1.4;
        word-break: break-word;
        overflow-wrap: anywhere;
    }
}
</style>